import {
  Component,
  OnInit,
  AfterViewInit,
  ViewEncapsulation,
  ViewChild,
  ElementRef,
  Renderer,
} from "@angular/core";
import { Router, ActivatedRoute, RouterLinkActive } from "@angular/router";
import { EventNameService } from "../../services/event-name.service";
// import Showcaser from 'showcaser';

@Component({
  selector: "app-dashboard",
  templateUrl: "./admin-common-layout.component.html",
  styleUrls: ["./admin-common-layout.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class AdminCommonLayoutComponent implements OnInit, AfterViewInit {
  @ViewChild("pubId") pubId: ElementRef;
  @ViewChild("moduleShowId") moduleShowId: ElementRef;
  @ViewChild("advId") advId: ElementRef;
  @ViewChild("customId") customId: ElementRef;
  userImg = undefined;
  public app: any;
  public headerThemes: any;
  public changeHeader: any;
  public sidenavThemes: any;
  public changeSidenav: any;
  public headerSelected: any;
  public sidenavSelected: any;
  public eventHeaderName: any;
  public organisationHeaderName: any;
  userName;
  maduleList = [];
  constructor(
    private router: Router,
    public eventNameService: EventNameService,
    private render: Renderer
  ) {
    this.userName = localStorage.getItem("userName");
    this.app = {
      layout: {
        sidePanelOpen: false,
        isMenuOpened: true,
        isMenuCollapsed: false,
        themeConfigOpen: false,
        rtlActived: false,
      },
    };

    this.headerThemes = [
      "header-default",
      "header-primary",
      "header-info",
      "header-success",
      "header-danger",
      "header-dark",
    ];
    this.changeHeader = changeHeader;

    function changeHeader(headerTheme) {
      this.headerSelected = headerTheme;
    }
    this.sidenavThemes = ["sidenav-default", "side-nav-dark"];
    this.changeSidenav = changeSidenav;
    function changeSidenav(sidenavTheme) {
      this.sidenavSelected = sidenavTheme;
    }
  }

  ngOnInit() {
    this.app.layout.isMenuCollapsed = false;
    this.userImg = localStorage.getItem("image");
    this.setEventName();
    this.getModuleNames();
  }

  onActivate(e, outlet) {
    window.scrollTo(0, 0);
  }

  onLogout() {
    const userId = localStorage.getItem("created_by");
    const dash = localStorage.getItem("dash");
    localStorage.clear();
    localStorage.setItem("created_by", userId);
    localStorage.setItem("dash", dash);
    this.router.navigateByUrl("/authentication/sign-in");
  }

  // Function to get the selected modules
  getModuleNames() {
    let moduleRoutesC;
    for (let i = 0; i < 9; i++) {
      switch (i) {
        case 1: {
          moduleRoutesC = "/programs/create";
          break;
        }
        case 2: {
          moduleRoutesC = "/materials/create";
          break;
        }
        case 3: {
          moduleRoutesC = "/news/create";
          break;
        }
        case 4: {
          moduleRoutesC = "/speakers/create";
          break;
        }
        case 5: {
          moduleRoutesC = "/participants/create";
          break;
        }
        case 6: {
          moduleRoutesC = "/feedback/create";
          break;
        }
        case 7: {
          moduleRoutesC = "/social/create";
          break;
        }
        case 8: {
          moduleRoutesC = "/twitter/create";
          break;
        }
        default: {
          moduleRoutesC = "/programs/create";
          break;
        }
      }
      this.maduleList[i] = {
        moduleName: localStorage.getItem("" + i),
        moduleOrder: localStorage.getItem(localStorage.getItem("" + i)),
        moduleRoutesC: moduleRoutesC,
      };
    }
    let newArray = new Array();
    for (let i = 0; i < this.maduleList.length; i++) {
      if (this.maduleList[i].moduleName) {
        newArray.push(this.maduleList[i]);
      }
    }
    newArray.sort((a, b) => {
      return a.moduleOrder - b.moduleOrder;
    });
    this.maduleList = newArray;
  }

  ngAfterViewInit() {
    this.eventHeaderName = localStorage.getItem("eventName");
    this.organisationHeaderName = localStorage.getItem("organisation_name");
    // console.log(localStorage.getItem('organisation_name'));
    this.getModuleNames();
    // if (localStorage.getItem('dash') == '0') {

    //     Showcaser.showcase("Manage contents of modules", this.moduleShowId.nativeElement, {
    //         shape: 'rectangle',
    //         positionTracker: true,
    //         scrollBufferPx: 0,
    //         before:()=>{this.app.layout.isMenuCollapsed = true;},
    //         close:()=>{this.customId.nativeElement.click() },
    //         position: {
    //             horizontal: "right",
    //             vertical: "middle"
    //         }
    //     });

    //     Showcaser.showcase("Customise the module", this.customId.nativeElement, {
    //         shape: 'rectangle',
    //         positionTracker: true,
    //         scrollBufferPx: 0,
    //         close:()=>{this.pubId.nativeElement.click() },
    //         position: {
    //             horizontal: "right",
    //             vertical: "middle"
    //         }
    //     });

    //     Showcaser.showcase("Publish the Event", this.pubId.nativeElement, {
    //         shape: 'rectangle',
    //         positionTracker: true,
    //         scrollBufferPx: 200,
    //         close:()=>{this.app.layout.isMenuCollapsed = false;},
    //         position: {
    //             horizontal: "left",
    //             vertical: "bottom"
    //         }
    //     });
    // }
  }

  setEventName() {
    // if (localStorage.getItem('eventName')) {
    //     this.eventHeaderName = localStorage.getItem('eventName');
    // }
    this.eventNameService.getPageInit().subscribe((value) => {
      this.getModuleNames();
    });

    this.eventHeaderName = this.eventNameService
      .getEventName()
      .subscribe((value) => {
        if (value == "initialState") {
          this.eventHeaderName = localStorage.getItem("eventName");
        } else {
          this.eventHeaderName = value;
          localStorage.setItem("eventName", value);
        }
      });
  }
}



// WEBPACK FOOTER //
// C:/Users/neenu.korula/AA/eventorg-web/src/app/common/admin-common-layout/admin-common-layout.component.ts